import { MaskedLine, Overline, Reveal } from "@/components/Reveal";

export default function PageHeader({ overline, title, accent, description, center = false }) {
  return (
    <header
      className={`relative pt-40 pb-16 sm:pb-24 px-6 sm:px-12 lg:px-20 max-w-7xl mx-auto ${
        center ? "text-center" : ""
      }`}
    >
      <Reveal y={20}>
        <Overline data-testid="page-overline">{overline}</Overline>
      </Reveal>
      <h1 className="font-serif text-5xl sm:text-6xl lg:text-8xl tracking-tight leading-[0.95] mt-6">
        <MaskedLine delay={0.1}>{title}</MaskedLine>
        {accent && (
          <MaskedLine delay={0.25}>
            <em className="text-primary">{accent}</em>
          </MaskedLine>
        )}
      </h1>
      {description && (
        <Reveal delay={0.4} className={`mt-8 max-w-xl ${center ? "mx-auto" : ""}`}>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            {description}
          </p>
        </Reveal>
      )}
    </header>
  );
}
